import styled from 'styled-components';

const SectionThreadDetail = styled.section`
  margin: 0 auto;
  margin-top: 32px; 
  width: 90%;
`;

export default SectionThreadDetail;
